import React, {   useRef,useEffect, useState, useCallback, useMemo } from 'react';
import { useSelector } from "react-redux"; 
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"  
import { useNavigate } from 'react-router-dom'; 
import { ENDPOINT } from "constants/variables"; 
import Box from '@mui/material/Box';  
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import "css/generalSettings.css";
import "css/customDialog.css"; 
import MenuItem  from "@mui/material/MenuItem"; 
import SendIcon from '@mui/icons-material/Send'; 
import Textarea from '@mui/joy/Textarea';
import { TextField } from '@mui/material';
import ReportTemplateContractFirst from 'pages/contracts/contractSendEmail/ReportTemplateContactFirst'; 
import ReportTemplateContractSecond from 'pages/contracts/contractSendEmail/ReportTemplateContractSecond'; 
import PropTypes from 'prop-types';  

const initialStateContractSendEmail = {
  id:0, 
  owncontract_id:0,
  defaultStore_id:0, 
  useraccount_id:0, 
  defaultformatnumber:0, 
  isFinished:true,
  isScanned:false,
  number_nt:"",
  date_contract:"",
  amount_contract:0, 
  periodicity_contract:"",
  duration_contract:"",
  other_information_contract1:"",
  other_information_contract2:"",
  conditions_contract1:"",
  conditions_contract2:"",
  obligations_contract1:"",
  obligations_contract2:"",

  title_opt_tras_tradename:"",
  title_opt_tras_name:"",
  title_opt_tras_street:"",
  title_opt_tras_nima:"",
  title_opt_tras_inscription:"",
  title2_opt_tras_tradename:"",
  title2_opt_tras_documentid:"",
  title2_opt_tras_street_fiscal:"",
  title2_opt_tras_postalcode_fiscal:"",
  title2_opt_tras_locality_fiscal:"",
  title2_street_fiscal:"",

  opt_tras_documnettype:"",
  opt_tras_documentid:"",
  opt_tras_tradename:"",
  opt_tras_name:"",
  opt_tras_contactname:"",
  opt_tras_nima:"",
  opt_tras_inscription:"",
  opt_tras_grnp:"",
  opt_tras_opt:"",
  opt_tras_phone:"",
  opt_tras_email:"",
  opt_tras_street:"",
  opt_tras_country:"",
  opt_tras_province:"",
  opt_tras_locality:"",
  opt_tras_postalcode:"",
  opt_tras_community:"",
  opt_tras_roadtype_fiscal:"",
  opt_tras_street_fiscal:"",
  opt_tras_country_fiscal:"",
  opt_tras_province_fiscal:"",
  opt_tras_locality_fiscal:"",
  opt_tras_postalcode_fiscal:"",
  opt_tras_community_fiscal:"",

  ori_tras_documnettype:"",
  ori_tras_documentid:"",
  ori_tras_tradename:"",
  ori_tras_name:"",
  ori_tras_contactname_documentid:"",
  ori_tras_contactname_firstaname:"",
  ori_tras_contactname_lastname:"", 
  ori_tras_contactname_position:"",
  ori_tras_contactname_email:"",
  ori_tras_contactname_phone:"",
  ori_tras_nima:"",
  ori_tras_inscription:"",
  ori_tras_grnp:"",
  ori_tras_opt:"",
  ori_tras_phone:"",
  ori_tras_email:"",
  ori_tras_street:"",
  ori_tras_country:"",
  ori_tras_province:"",
  ori_tras_locality:"",
  ori_tras_postalcode:"",
  ori_tras_community:"",
  ori_tras_roadtype_fiscal:"",
  ori_tras_street_fiscal:"",
  ori_tras_country_fiscal:"",
  ori_tras_province_fiscal:"",
  ori_tras_locality_fiscal:"",
  ori_tras_postalcode_fiscal:"",
  ori_tras_community_fiscal:"",

  aut_tras_documnettype:"",
  aut_tras_documentid:"",
  aut_tras_tradename:"",
  aut_tras_name:"",
  aut_tras_contactname:"",
  aut_tras_nima:"",
  aut_tras_inscription:"",
  aut_tras_grnp:"",
  aut_tras_opt:"",
  aut_tras_phone:"",
  aut_tras_email:"",
  aut_tras_street:"",
  aut_tras_country:"",
  aut_tras_province:"",
  aut_tras_locality:"",
  aut_tras_postalcode:"",
  aut_tras_community:"" ,

  dest_tras_documnettype:"",
  dest_tras_documentid:"",
  dest_tras_tradename:"",
  dest_tras_name:"",
  dest_tras_contactname:"",
  dest_tras_contactname_position:"",
  dest_tras_nima:"",
  dest_tras_inscription:"",
  dest_tras_grnp:"",
  dest_tras_opt:"",
  dest_tras_phone:"",
  dest_tras_email:"",
  dest_tras_street:"",
  dest_tras_country:"",
  dest_tras_province:"",
  dest_tras_locality:"",
  dest_tras_postalcode:"",
  dest_tras_community:"" ,
  dest_tras_street_fiscal:"" ,
  dest_tras_country_fiscal:"" ,
  dest_tras_province_fiscal:"" ,
  dest_tras_locality_fiscal:"" ,
  dest_tras_postalcode_fiscal:"" ,
  dest_tras_community_fiscal:"" ,
  
  aut_dest_documnettype:"",
  aut_dest_documentid:"",
  aut_dest_tradename:"",
  aut_dest_name:"",
  aut_dest_contactname:"",
  aut_dest_nima:"",
  aut_dest_inscription:"",
  aut_dest_grnp:"",
  aut_dest_opt:"",
  aut_dest_phone:"",
  aut_dest_email:"",
  aut_dest_street:"",
  aut_dest_country:"",
  aut_dest_province:"",
  aut_dest_locality:"",
  aut_dest_postalcode:"",
  aut_dest_community:"" ,
  signature_opt_tras:"" ,
  signature_ori_tras:"" ,
  signature_dest_tras:"" ,
  "opttrasbilling":false,
  "oritrasbilling":false,
  "desttrasbilling":true,
  "reltransbilling":false,
  contractCodeLERGroupedDTO:[],
  contractCodeLERGroupedFormatTxeixoDTO:[]
  
}; 

const initialStateEMAIL = {
  "id":"",
  "defaultStore_id":0, 
  "useraccount_id":0,
  "store_EmailTo":"",
  "subjectEmail":"",
  "contentEmail":"",
  "filetosend":[] 
}; 

const initialEmailToSelect = [{
  "id": "",
  "email": "" 
}];

const ContractSendEmail = ({id, showModalContractSendEmail}) => {
  const {t,i18n} = useTranslation(['listDataContracts']);
  const token = useSelector((state) => state.loginUser.token);   
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const footeremail = useSelector((state) => state.loginUser.defaultticketsformat.footeremail);
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi.formatnumber);  
  const headerPrinterPurchase = useSelector(
    (state) => state.loginUser.defaultticketsformat.headerPrinterPurchase
  );
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const [dataForm, setDataForm] = useState(initialStateContractSendEmail);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [formEMAIL, setFormEMAIL] = useState(initialStateEMAIL);
  const [errorsEMAIL, setErrorsEMAIL] = useState({});
  const [pdfBlob, setPdfBlob] = useState(null); 
  const [emailToSelect,setEmailToSelect]= useState(initialEmailToSelect);  
  const [filteredEmail, setFilteredEmail] = useState([]); // Opciones filtradas
  const [highlightedIndexEmail, setHighlightedIndexEmail] = useState(-1); // Índice de la opción resaltada 
  const [pdfUrl, setPdfUrl] = useState(""); // Estado para actualizar el PDF

  const PdfViewer = useMemo(() => {
    return pdfUrl?
      <iframe
        src={pdfUrl} 
        title="PDF Preview"
        style={{ width: '100%', height: '100%', border: 'none' }}
      /> 
    :pdfBlob ? (
      <iframe
        src={URL.createObjectURL(pdfBlob)}
        title="PDF Preview"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    ) : null;
  }, [pdfBlob,pdfUrl]);

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalContractSendEmail) {
        setDataForm(initialStateContractSendEmail);
        setDataForm(dataForm => ({
          ...dataForm,
          contractCodeLERGroupedDTO:[],
          contractCodeLERGroupedFormatTxeixoDTO:[]
        }));
        dispatch(setLoading(false));  
        setPdfBlob(null); 
        setFormEMAIL(initialStateEMAIL);
        setErrorsEMAIL({});
        setEmailToSelect(initialEmailToSelect);
        setFilteredEmail([]);
        setHighlightedIndexEmail(-1); 
        setPdfUrl("");
        navigate("/contract");
      }
    },
    [
      setDataForm,  
      setPdfBlob,    
      showModalContractSendEmail,
      setEmailToSelect,
      setFilteredEmail,
      setHighlightedIndexEmail,
      setPdfUrl,
      dispatch,
      navigate]
  );
  
  const handleCloseSendEmailContract = () => {
    setDataForm(initialStateContractSendEmail);
    setDataForm(dataForm => ({
      ...dataForm,
      contractCodeLERGroupedDTO:[],
      contractCodeLERGroupedFormatTxeixoDTO:[]
    }));
    dispatch(setLoading(false));
    setPdfBlob(null);   
    setFormEMAIL(initialStateEMAIL);
    setErrorsEMAIL({});
    setEmailToSelect(initialEmailToSelect);
    setFilteredEmail([]);
    setPdfUrl("");
    setHighlightedIndexEmail(-1); 
    navigate("/contract"); 
	};

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
  };
  // Dentro del componente
  const debouncedHandleSearchEmail= useDebounce((searchValue) => {
    const upperValue = searchValue.toLowerCase();
    if (upperValue.trim() === "") {
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
      return;
    }
    const filtered = emailToSelect
        .filter(store => store && store.email)
        .filter(store => {
        const emails = store.email.toLowerCase();
        return emails.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
      setFilteredEmail(filtered);
      setHighlightedIndexEmail(0);
  }, 300);   
  const handleSelectEmail = (email) => {
    if (!email) return; // Validación adicional para evitar errores
    setFormEMAIL((formEMAIL) => ({
      ...formEMAIL,
      store_EmailTo: email.email || ""
      
    }));
    setFilteredEmail([]);
    setHighlightedIndexEmail(-1);
  }; 

  const handleKeyDownEmail = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredEmail.length === 0 && formEMAIL.store_EmailTo.trim() === "") {
        setFilteredEmail(emailToSelect);
        setHighlightedIndexEmail(0);
      } else {
        setHighlightedIndexEmail((prevIndex) => {
          const nextIndex = prevIndex < filteredEmail.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexEmail((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexEmail >= 0) {
      if (highlightedIndexEmail >= 0 && highlightedIndexEmail < filteredEmail.length) {
        handleSelectEmail(filteredEmail[highlightedIndexEmail]);
      }
    } else if (event.key === "Escape") {
      const isValid = emailToSelect.some((email) => {
        if (!email || !email.workplace) return false; 
        const normalizedEmail = email.email.toLowerCase();
        const normalizedInputEmail = formEMAIL.store_EmailTo.toLowerCase();
        return normalizedEmail === normalizedInputEmail;
      }); 
      if (!isValid) {
        setFormEMAIL((formEMAIL) => ({
          ...formEMAIL,
          store_EmailTo: "",
        }));
      } 
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
    }
  };

  // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };
  
   const handleBlur = useCallback((event) => {
       if (!event || !event.currentTarget) return;
       // Asegúrate de que no se cierra si haces clic en un elemento de la lista
       if (!event.currentTarget.contains(event.relatedTarget)) {
        setFilteredEmail([]);
        setHighlightedIndexEmail(-1);
      }
    }, []);
    

  const handleBlurDataEditEmail = (e) => {
    handleChangeDataEditEmail(e);
    setErrorsEMAIL(validateFormEmail());
  };

  const handleChangeDataEditEmail = (e) => {
    const { name, value } = e.target;
    setFormEMAIL(formEMAIL => ({
      ...formEMAIL,
      [name]: value,
    })); 
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob); // ✅ Convierte el Blob a Base64
      reader.onloadend = () => resolve(reader.result.split(",")[1]); // ✅ Remueve "data:application/pdf;base64,"
      reader.onerror = reject;
    });
  };

  const validateFormEmail = () => {
    let errorsEMAIL = {};
    //let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (!formEMAIL.store_EmailTo || formEMAIL.store_EmailTo==="") {
      errorsEMAIL.store_EmailTo = 'Text_FieldSendEmailToRequired'; 
    } else {
      if (regexInvalidCharacters.test(formEMAIL.store_EmailTo)) {
        errorsEMAIL.store_EmailTo = 'Text_TextNoValid';
      }
    }  

    if (regexInvalidCharacters.test(formEMAIL.subjectEmail)) {
      errorsEMAIL.subjectEmail = 'Text_TextNoValid';
    }

    if (regexInvalidCharacters.test(formEMAIL.contentEmail)) {
      errorsEMAIL.contentEmail = 'Text_TextNoValid';
    }  
    return errorsEMAIL;
  };

  const handleConfirmFetchSendFCT= async (formData) => { 
    handleCloseSendEmailContract(); 
    const fetchData = async () => {  
      try {
        const getData = await helpHttp().postemail(ENDPOINT, `api/sendemailwithattachment`, token,formData); 
        if (getData.status === "OK") {
          dispatch(setLoading(false));
          dispatch(successErrorAction(t('Text_EMAIL_Sended')));
        } else {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.cause)));
        } 
      } catch (error) { 
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }   
      return () => {  };
    }; 
    fetchData();  
};

  const handleSubmitSendEmail =  async ()=>{
    const errors = validateFormEmail();
    setErrorsEMAIL(errors);  
    const hasNoErrors = Object.keys(errors).length === 0;
    const emailToOk = formEMAIL?.store_EmailTo?.trim();
    const hasPdf = !!pdfBlob || !!pdfUrl;
    if (!hasNoErrors || !emailToOk || !hasPdf) {
        if (errors.store_EmailTo) dispatch(warningErrorAction(t(errors.store_EmailTo)));
      else if (errors.subjectEmail) dispatch(warningErrorAction(t(errors.subjectEmail)));
      else if (errors.contentEmail) dispatch(warningErrorAction(t(errors.contentEmail)));
      else if (!hasPdf) dispatch(warningErrorAction(t("Text_FieldSendEmailToRequired")));
      else dispatch(warningErrorAction(t("Text_IncorrectData")));
      return;
    } 
    
    dispatch(setLoading(true));
    if (pdfBlob){
        // ✅ Convertir Blob a Base64 sin detener la ejecución
      blobToBase64(pdfBlob)
      .then((base64File) => {
        const formData = {
          id: id,
          defaultStore_id: defaultStore.id,
          useraccount_id: useraccount_id,
          store_EmailTo: formEMAIL.store_EmailTo,
          subjectEmail: formEMAIL.subjectEmail,
          contentEmail: formEMAIL.contentEmail,
          filetosend: base64File, 
          fileName: `CONTRATO_${dataForm.owncontract_id.toString().padStart(8, '0')}.pdf`,
          fileType: "application/pdf",
        }; 
        // ✅ Llamada asíncrona sin bloquear el flujo 
        handleConfirmFetchSendFCT(formData);
      })
      .catch((error) => {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }); 
    }else{
      if (pdfUrl) {
        fetch(pdfUrl)
          .then(response => response.blob()) // Convertir la URL en un Blob
          .then(blob => blobToBase64(blob)) // Convertir el Blob en Base64
          .then((base64File) => {
            const formData = {
              id: id,
              defaultStore_id: defaultStore.id,
              useraccount_id: useraccount_id,
              store_EmailTo: formEMAIL.store_EmailTo,
              subjectEmail: formEMAIL.subjectEmail,
              contentEmail: formEMAIL.contentEmail,
              filetosend: base64File,
              fileName:`CONTRATO_${formEMAIL.owncontract_id.toString().padStart(8, '0')}.pdf`,
              fileType: "application/pdf",
            };
            // ✅ Llamada asíncrona sin bloquear el flujo
            handleConfirmFetchSendFCT(formData);
          })
          .catch((error) => {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData22')));
          });
      } 
    }  
  };  

  useEffect(() => {
    let isMounted = true; 
    const fetchDataEmail = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`api/getlistemails/`,token,
          (formEMAIL.store_EmailTo!==undefined && formEMAIL.store_EmailTo!==null && formEMAIL.store_EmailTo.replace(/[.;\-/\\|]/g, "").trim()!=="")?formEMAIL.store_EmailTo.replace(/[.;\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setEmailToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    
    if (showModalContractSendEmail && formEMAIL.store_EmailTo && formEMAIL.store_EmailTo.replace(/[.;\-/\\|]/g, "").trim()!=="") { 
      fetchDataEmail();
    }else{
      setEmailToSelect(initialEmailToSelect);
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,showModalContractSendEmail,formEMAIL.store_EmailTo]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (pdfBlob) { 
      const formatted_id= (dataForm.owncontract_id!==undefined && dataForm.owncontract_id!==""  && dataForm.owncontract_id!==0)?`CONTRACT_${dataForm.owncontract_id}.pdf`:`CONTRACT_${id.toString().padStart(8, '0')}.pdf`;
      const file = new File([pdfBlob], formatted_id, { type: "application/pdf" });
      setFormEMAIL((formEMAIL) => ({
        ...formEMAIL,
        filetosend: file // Se almacena directamente como un único archivo
      }));
    }
  }, [pdfBlob,id,dataForm.owncontract_id]);    
  
  useEffect(() => {
    let isMounted = true;
    const fetchDataShipping = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get8(ENDPOINT, `contract/getpdfcontractbyid`, token, id, defaulttypesdi); 
        if (getData.err) {
          setDataForm(initialStateContractSendEmail); 
          setDataForm(dataForm => ({
            ...dataForm,
            contractCodeLERGroupedDTO:[],
            contractCodeLERGroupedFormatTxeixoDTO:[]
          }));
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataForm(getData);
          let subjectNumber=getData.owncontract_id;
          setFormEMAIL(formEMAIL => ({
            ...formEMAIL,
            defaultStore_id:defaultStore.id,
            useraccount_id:useraccount_id,
            store_EmailTo: [...new Set(
              [getData.opt_tras_email, getData.ori_tras_email,getData.aut_tras_email,getData.dest_tras_email,getData.aut_dest_email]
                .filter(email => email && email.trim() !== "")
                .map(email => email.trim().toLowerCase()) // opcional: para evitar duplicados por mayúsculas/minúsculas
            )].join(";"), 
            subjectEmail:"LE REMITO EL CONTRATO Nº: "+subjectNumber,
            contentEmail:footeremail
          })); 
        
          if (getData.isScanned){
            setPdfBlob(null)
            let fileName = "CONTRATO_"+getData.owncontract_id+ ".pdf"; 
            fetchDataShipping(fileName); 
          } 
          dispatch(setLoading(false));
        }  
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    if (id!=="0"){
      if (!dataForm.id || dataForm.id==="" || dataForm.id===0){
        fetchDataShipping(); 
        dispatch(setLoading(false));
      }
    }else{
      setDataForm(initialStateContractSendEmail);
      setDataForm(dataForm => ({
        ...dataForm,
        contractCodeLERGroupedDTO:[],
        contractCodeLERGroupedFormatTxeixoDTO:[]
      }));
      setFormEMAIL(formEMAIL => ({
        ...formEMAIL,
        defaultStore_id:defaultStore.id,
        useraccount_id:useraccount_id,
        contentEmail:footeremail
      })); 
      dispatch(setLoading(false));
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,pdfBlob,dataForm.id,defaultStore.id,useraccount_id,footeremail,dataForm.owncontract_id,defaulttypesdi]);  

  return (
    <>
      {showModalContractSendEmail ? ( 
        <div className="container-fluid email-send-wrapper">
          <Box sx={{ bgcolor: '#ffffff', width: '1050px' }}>
            <form onSubmit={handleCloseSendEmailContract}>
              {/* HEADER */}
              <div className="email-card-header">
                <div className="email-header-content">
                  <div className="email-header-icon">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="email-header-text">
                    <div className="email-header-title">
                      {t('Text_NumberForm_EMAIL')}:
                    </div>
                    <div className="email-header-number">
                      {dataForm.owncontract_id}
                    </div>
                  </div>
                  <div className="email-card-actions">
                    {!isLoadingData && (
                      <>
                        <button type="button" className="email-send-btn" onClick={handleSubmitSendEmail} >
                          {t('Button_Send')}
                          <SendIcon sx={{ fontSize: 22, color: "white" }} />
                        </button>
                        <button type="button" className="email-cancel-btn" onClick={handleCloseSendEmailContract} >
                          {t('Button_Cancel')}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
       
             {/* FORM CARD */}
              {!isLoadingData ? (
                <>
                  <div className="email-card-form">
                    <div className="row g-3">
                      {/* Email To */}
                      <div className="col-12 email-input" style={{ position: 'relative' }}>
                        <label className="text-primary" style={{ fontSize: 18 }}>
                          {t('Text_SENDEMAIL_EmailsTo')} :
                        </label>
                        <TextField
                          id="store_EmailTo"
                          name="store_EmailTo"
                          value={formEMAIL.store_EmailTo}
                          onChange={(e) => {
                            setFormEMAIL(prev => ({ ...prev, store_EmailTo: e.target.value.toLowerCase() }));
                            debouncedHandleSearchEmail(e.target.value);
                          }}
                          onKeyDown={handleKeyDownEmail}
                          onBlur={(event) => {
                            if (!event.relatedTarget || !event.relatedTarget.closest(".email-suggest-dropdown")) {
                              handleBlur();
                            }
                          }}
                          label={
                            errorsEMAIL.store_EmailTo != null
                              ? t(errorsEMAIL.store_EmailTo)
                              : t('PlaceHolder_SENDEMAIL_EmailsTo')
                          }
                          placeholder={t('PlaceHolder_SENDEMAIL_EmailsTo')}
                          variant="standard"
                          inputProps={{ style: { width: i18n.language === 'es' ? 738 : 867 } , maxLength: 100 }}
                          InputLabelProps={{ style: { fontSize: 18, background: '#FFFFFF' } }}
                        />
                      {/* Desplegable dinámico */}
                      {filteredEmail.length > 0 && (
                          <div className="email-suggest-dropdown" onMouseDown={(e) => e.preventDefault()}>
                            {filteredEmail.map((store, index) => (
                              <MenuItem
                                key={store.id}
                                onClick={() => handleSelectEmail(store)}
                                style={{
                                  cursor: "pointer",
                                  padding: "10px 12px",
                                  borderBottom: "1px solid #eee",
                                  fontSize: 18,
                                  backgroundColor: index === highlightedIndexEmail ? "#4e73df" : "transparent",
                                  color: index === highlightedIndexEmail ? "white" : "black",
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                {store.email}
                              </MenuItem>
                            ))}
                          </div>
                        )}
                      </div>
                      
                      
                     {/* Subject */}
                      <div className="col-12 email-input">
                        <label className="text-primary" style={{ fontSize: 18 }}>
                          {t('Text_SENDEMAIL_Subject')}
                        </label>
                        <TextField
                          id="subjectEmail"
                          name="subjectEmail"
                          value={formEMAIL.subjectEmail ?? ""}
                          inputProps={{ style: { width: i18n.language === "es" ? 941 : 937 }, maxLength: 100 }}
                          InputLabelProps={{ style: { fontSize: 18, background: '#FFFFFF' } }}
                          label={
                            errorsEMAIL.subjectEmail != null
                              ? t(errorsEMAIL.subjectEmail)
                              : t('PlaceHolder_SENDEMAIL_Subject')
                          }
                          placeholder={t('PlaceHolder_SENDEMAIL_Subject')}
                          variant="standard"
                          onBlur={handleBlurDataEditEmail}
                          onChange={handleChangeDataEditEmail}
                        />
                      </div> 

                        {/* Content */}
                      <div className="col-12">
                        <label className="text-primary" style={{ fontSize: 18 }}>
                          {t('Text_SENDEMAIL_Content')} :
                        </label>
                        <Textarea
                          id="contentEmail"
                          name="contentEmail"
                          value={formEMAIL.contentEmail}
                          className="email-textarea"
                          label={
                            errorsEMAIL.contentEmail != null
                              ? t(errorsEMAIL.contentEmail)
                              : t('PlaceHolder_SENDEMAIL_Content')
                          }
                          placeholder={t('PlaceHolder_SENDEMAIL_Content')}
                          sx={{ width: 1020, fontSize: 18 }}
                          variant="standard"
                          onBlur={handleBlurDataEditEmail}
                          onChange={handleChangeDataEditEmail}
                          maxRows={8}
                        />
                      </div>
                    </div>
                  </div> 
                  {/* PDF CARD */}
                  <div className="email-card-pdf">
                    {PdfViewer}
                  </div>
                </>
              ):
                <LoadingNews/>
              }
            </form>
          </Box>  
            {!pdfUrl && (defaulttypesdi===1?
              <ReportTemplateContractFirst dataForm={dataForm}  setPdfBlob={setPdfBlob} headerPrinterPurchase={headerPrinterPurchase}/>:
              <ReportTemplateContractSecond dataForm={dataForm} setPdfBlob={setPdfBlob}/>)
            }
            <br/>
          </div>
        //* End Page Content *//
      ) :  null }
    </>
  )    
}

ContractSendEmail.propTypes = {
  id: PropTypes.string.isRequired,
  showModalContractSendEmail: PropTypes.bool.isRequired
};

export default ContractSendEmail;